import { Component, Input } from '@angular/core';
import { ApiGatewayService, RegisteredDevice, UserProfile } from 'src/app/services/api-gateway.service';
import { InfoMessageService, emitInfoMessage } from 'src/app/services/info-message.service';

@Component({
  selector: 'app-get-started-with-multinode',
  templateUrl: './get-started-with-multinode.component.html',
  standalone: false
})
export class GetStartedWithMultinodeComponent {
  @Input() profile: UserProfile | null = null;
  nodes?: RegisteredDevice[]
  loadingNodes: boolean = true

  constructor(private gatewayApiService: ApiGatewayService,
    private infoMessageService: InfoMessageService){
  }

  async ngOnInit(){
    this.getNodes();
  }

  async getNodes(){
    await this.gatewayApiService.getRegisteredDevices()
    .then((data) => {
      if (data.body){
        this.nodes = data.body
          .sort((a, b) => (a.description ?? '').toLowerCase().localeCompare((b.description ?? '').toLowerCase()))
          .slice(0, 3)
      }
      this.loadingNodes = false;
    })
    .catch((error) => {
      this.loadingNodes = false;
      emitInfoMessage(error.status +": "+ error.statusText, this.infoMessageService)
    })
  }
}
